import React from "react";
import { ImageTwo, ImageThree } from "../assets/images";

const ThirdTab = () => {
  return (
    <div
      className="max-w-9xl mx-auto px-6 pt-6 bg-white shadow-md flex flex-col lg:flex-row items-center lg:items-start"
      style={{
        paddingRight: "70px",
        paddingLeft: "70px",
        marginTop: "0px",
        marginBottom: "0px",
      }}
    >
      {/* Left Section - Text */}
      <div className="flex-[1.2] space-y-6">
        <h3 className="text-gray-800 text-base md:text-lg lg:text-2xl font-medium">
          Empfly Pulse
        </h3>

        <h1
          className="text-3xl md:text-4xl lg:text-5xl leading-tight"
          style={{ color: "#2f4d23" }}
        >
          Backed by Experts
        </h1>

        <p className="text-xl lg:text-4xl" style={{ color: "#2f4d23" }}>
          Trusted care, guided by science and empathy.
        </p>

        <p className="text-lg text-gray-700 lg:text-3xl leading-relaxed">
          Empfly Pulse is built with the guidance of
          <br />
          <strong>
            oncologists, cancer specialists, psychologists,
            <br />
            nutritionists{" "}
          </strong>
          and <strong>physiologists</strong>.
        </p>

        {/* Highlight Box — adjusted width */}
        <div className="inline-block bg-pink-100 p-4 lg:text-5xl md:p-6 rounded-2xl">
          <p className="text-gray-700 text-base md:text-lg leading-relaxed">
            Recovery modules are designed
            <br />
            with <strong>clinical</strong> insight and compassionate
            <br />
            <strong>expertise</strong>, ensuring your healing journey
            <br />
            is both safe and personalized.
          </p>
        </div>

        {/* Footer Tags */}
        <p className="text-xl text-gray-500 lg:text-4xl ">
          🩺 Clinical Expertise • Compassion • Personalization
        </p>
      </div>

      {/* Right Section - Images */}
      <div className="flex-1 flex flex-col items-center lg:items-end justify-between gap-0">
        <img
          src={ImageTwo}
          alt="Stethoscope with Ribbon"
          className="w-48 h-52 md:w-56 md:h-60 object-contain"
        />
        <img
          src={ImageThree}
          alt="Group of Medical Experts"
          className="w-full max-w-sm md:max-w-md rounded-2xl object-cover"
        />
      </div>
    </div>
  );
};

export default ThirdTab;
